


















import { Vue, Prop, Component } from 'vue-property-decorator';
import { ESidebarOptionType } from '@signing-page/documents/types/enums/sidebar-option-type';
import { IDocumentOption } from '@signing-page/documents/types/document-option';
import { DURATION } from '@signing-page/common/constants/tooltip';

@Component({
  data: () => ({
    ESidebarOptionType,
  }),
})
export default class DocumentAction extends Vue {
  @Prop() option: IDocumentOption;
  @Prop() isPreview: boolean;
  @Prop() isPrinting!: boolean;

  tooltipOpen = false;

  showTooltip() {
    if (this.tooltipOpen) {
      return;
    }
    this.tooltipOpen = true;
    setTimeout(() => {
      this.tooltipOpen = false;
    }, DURATION);
  }

  get previewDisable(): boolean {
    return this.option.disableInPreview && this.isPreview;
  }

  get printing(): boolean {
    return this.isPrinting && this.option.type === ESidebarOptionType.Print;
  }

  get tooltipText(): string {
    if (this.previewDisable) {
      return this.$t(`disabled-in-preview-mode`).toString();
    }
    if (this.printing) {
      return this.$t(`preparing-print`).toString();
    }
    return null;
  }

  handleClick() {
    if (this.previewDisable || this.printing) {
      this.showTooltip();
      return;
    }
    this.$emit('click', this.option.type);
  }
}
